export default __webpack_public_path__ + "static/media/vl_cropped.68c10cd5.png";